// src/components/MapView.js
import React from 'react';

const MapView = ({ status, iframeSrc, errorMessage, addressStreet }) => {
    return (
        <div className="map-embed-container">
            {status === 'loading' && (
                <div className="map-placeholder map-loading-state">
                    <div className="map-loader"></div>
                    <span>Locating Address...</span>
                </div>
            )}
            {status === 'error' && (
                <div className="map-placeholder">
                    <span>{errorMessage || 'Address could not be located on the map.'}</span>
                </div>
            )}
            {status === 'success' && iframeSrc && (
                <iframe
                    title={`Map of ${addressStreet}`}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                    src={iframeSrc}
                ></iframe>
            )}
        </div>
    );
};

export default MapView;